import React from 'react';
// Modules
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
// Components
import CTALogClassesTable from './classes/CTALogClassesTable';
import CTALogTypesTable from './types/CTALogTypesTable';

export default function CTALogElements() {
  return (
    <Row className="gx-5">
      <Col>
        <CTALogClassesTable />
      </Col>
      <Col>
        <CTALogTypesTable />
      </Col>
    </Row>
  );
}
